import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AbstractSecondaryToolbar } from '../../../../cross-team-shared/annotation/shared/toolbars/secondary-toolbar/abstract-secondary-toolbar';
import { toggleState } from '../../../../shared/misc-utilities/store-utils';
import { ImageContentState } from '../../state/image-content-state';
import { ImageContentStore } from '../../state/image-content-store';
import { PaintbrushTool } from './paintbrush-tool';

@Component({
  selector: 'h3-paintbrush-secondary-toolbar',
  templateUrl: './paintbrush-secondary-toolbar.component.html',
  styleUrls: ['./paintbrush-secondary-toolbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PaintbrushSecondaryToolbarComponent extends AbstractSecondaryToolbar<
  ImageContentState,
  ImageContentStore,
  PaintbrushTool
> {
  store = inject(ImageContentStore);

  toggleLockMask() {
    toggleState(this.store('lockMask'));
  }
}
